import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'
import BaixarDocumentoInput from '@/core/apiclient/pedido/documentos/models/BaixarDocumentoPedidoInput'
import ExcluirDocumentoPedidoInput from '@/core/apiclient/pedido/documentos/models/ExcluirDocumentoPedidoInput'

const URL_PATH = 'api/pedido'

class DocumentosPedidoApiClient {
	async buscarListagem(filtro, paginacao, idPedido, modalPenalidade) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idPedido}/documentos`,
			filters: { ...filtro, ...modalPenalidade },
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async excluir(documento) {
		const input = new ExcluirDocumentoPedidoInput(documento)

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${input.idDocumentoAta}`,
			filters: input.filtros,
		}).build()

		return await axios.delete(url)
	}

	async baixar(documento) {
		const baixarDocumentoPedidoInput = new BaixarDocumentoInput(documento)

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${baixarDocumentoPedidoInput.idDocumentoPedido}/baixar`,
			filters: {
				tipoRegistroDocumento: baixarDocumentoPedidoInput.tipoRegistroDocumento,
				situacaoDocumento: baixarDocumentoPedidoInput.situacao,
			},
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}

	async buscarEmailFornecedor(idDocumento){
		return await axios.get(`${URL_PATH}/documentos/${idDocumento}/buscar-email-fornecedor`)
	}

	async enviarDocumentoOrdemUtilizacaoParaFornecedor({ emailFornecedor, idDocumento, emailDocumentoPedido }) {
		await axios.post(`${URL_PATH}/documentos/${idDocumento}/enviar-fornecedor`, {
			emailFornecedor,
			emailDocumentoPedido,
		})
	}
}

export default new DocumentosPedidoApiClient()
